<template>
  <div class="mt-3">
    <div class="header-purple">
      <div>
        <p class="mb-0">
          <strong>
            รายละเอียด
            <b-button
              v-if="collapseHeader"
              variant="link"
              size="sm"
              class="btn-collapse mb-1"
              @click="collapseHeader = false"
            >
              <b-icon icon="chevron-down"></b-icon>
            </b-button>
            <b-button
              v-if="!collapseHeader"
              variant="link"
              size="sm"
              class="btn-collapse  mb-1"
              @click="collapseHeader = true"
            >
              <b-icon icon="chevron-up"></b-icon>
            </b-button>
          </strong>
        </p>
      </div>
    </div>
    <b-collapse v-model="collapseHeader" class="collapse-header">
      <div class="bg-white">
        <b-container class="p-0">
          <b-table
            responsive
            :thead-tr-class="thTableProduct"
            :tbody-tr-class="trTableProduct"
            class="text-center table-p-th"
            :fields="fields"
            :items="details"
            :busy="isBusy"
            show-empty
            empty-text="ไม่พบข้อมูล"
          >
            <template v-slot:head(statusLogDateTime)="">
              <div class="border-right">
                <strong>วันที่ และ เวลา</strong>
              </div> </template
            ><template v-slot:head(description)="">
              <div class="border-right">
                <strong>รายละเอียด</strong>
              </div> </template
            ><template v-slot:head(statusLog)="">
              <div class="border-right">
                <strong>สถานะ</strong>
              </div>
            </template>
            <template v-slot:cell(statusLogDateTime)="data">
              <div v-if="data.item.statusLogDateTime">
                <span class="m-0"
                  >{{
                    new Date(data.item.statusLogDateTime) | moment($formatDate)
                  }}
                </span>
                <span class="text-gray">
                  ({{
                    new Date(data.item.statusLogDateTime) | moment($formatTime)
                  }})
                </span>
              </div>
              <div v-else><p class="m-0">-</p></div>
            </template>
            <template v-slot:cell(description)="data">
              <div v-if="data.item.description">
                <p class="m-0">{{ data.item.description }}</p>
              </div>
              <div v-else><p class="m-0">-</p></div>
            </template>
            <template v-slot:cell(statusLog)="data">
              <div v-if="data.item.statusLog">
                <p class="m-0">{{ data.item.statusLog }}</p>
              </div>
              <div v-else><p class="m-0">-</p></div>
            </template>
            <template v-slot:cell(statusLogBy)="data">
              <div v-if="data.item.statusLogBy">
                <p class="m-0">{{ data.item.statusLogBy }}</p>
              </div>
              <div v-else><p class="m-0">-</p></div>
            </template>
            <template slot="bottom-row">
              <td class="last-row"></td>
              <td class="last-row"></td>
              <td class="last-row"></td>
              <td class="last-row"></td>
            </template>
          </b-table>
        </b-container>
      </div>
    </b-collapse>
  </div>
</template>

<script>
import { BIcon } from "bootstrap-vue";
export default {
  name: "DetailPanel",
  components: { BIcon },
  props: {
    details: {
      type: Array,
      isRequired: true,
    },
  },
  data() {
    return {
      collapseHeader: true,
      fields: [
        {
          key: "statusLogDateTime",
          label: `วันที่ และ เวลา`,
          class: "w-50px text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
          },
        },
        {
          key: "description",
          label: `รายละเอียด`,
          class: "w-50px text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
          },
        },
        {
          key: "statusLog",
          label: `สถานะ`,
          class: "w-100px text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
          },
        },
        {
          key: "statusLogBy",
          label: `โดย`,
          class: "w-100px text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
          },
        },
      ],
      thTableProduct: {
        "border-bottom": "2px solid #f8f8f8 !important",
        "min-height": "80px !important",
      },
      trTableProduct: { "border-bottom": "2px solid #f8f8f8 !important" },
      isBusy: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.btn-collapse {
  color: #333333;
}
.text-gray {
  color: #bcbcbc;
}
.last-row {
  height: 47.4px;
  border-top: 2px solid white;
}
</style>
